import { Box } from '@mui/system'
import { Card, CardContent, Typography } from '@mui/material'

export default function NoProfileLayout(props = {}) {
  return (
    <div className="content-wrapper">
      <section className="content body">
        <Box sx={{ maxWidth: 400 }} margin='auto' pt='100px'>
          <Card variant='outlined' >
            <CardContent>
            <Typography variant='body1' color='InfoText'>
              We could not find a role for your account. Your NAOU QSE sponsor will need to provide a role for you.
              You may refresh the page when your NAOU QSE sponsor confirms they have created a role,
              or logout and try again later.
            </Typography>
            </CardContent>
          </Card>
        </Box>
      </section>
    </div>
  )
}